import type { Clip } from "../types";
import { GalleryCard } from "./GalleryCard";

interface GalleryGridProps {
  clips: Clip[];
  loading: boolean;
  bangeredIds: Set<string>;
  bangerBusyIds: Set<string>;
  isAdmin: boolean;
  deletingIds: Set<string>;
  onOpen: (clip: Clip) => void;
  onBanger: (clip: Clip) => void;
  onDelete: (clip: Clip) => void;
  onShare: (clip: Clip) => void;
}

export function GalleryGrid({ clips, loading, bangeredIds, bangerBusyIds, isAdmin, deletingIds, onOpen, onBanger, onDelete, onShare }: GalleryGridProps) {
  if (loading) {
    return (
      <div className="clip-grid" aria-label="Loading clips" aria-busy="true">
        {Array.from({ length: 8 }, (_, index) => (
          <div className="clip-card clip-skeleton" key={index}>
            <span className="clip-card-media" />
            <span className="clip-card-copy"><i /><i /><i /></span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="clip-grid">
      {clips.map((clip) => (
        <GalleryCard
          key={clip.id}
          clip={clip}
          bangered={bangeredIds.has(clip.id)}
          bangerBusy={bangerBusyIds.has(clip.id)}
          isAdmin={isAdmin}
          deleting={deletingIds.has(clip.id)}
          onOpen={onOpen}
          onBanger={onBanger}
          onDelete={onDelete}
          onShare={onShare}
        />
      ))}
    </div>
  );
}
